/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export enum MediaPaneType {
  IPTV = "iptv",
  TMIS = "tmis"
}
